module.exports = require("threads");